import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-758ff676"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  ref: "modal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-scrollable" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, " Your Results "),
  /*#__PURE__*/_createElementVNode("button", {
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bubble_graph = _resolveComponent("bubble-graph")!
  const _component_bar_graph = _resolveComponent("bar-graph")!
  const _component_message_wrapper = _resolveComponent("message-wrapper")!

  return (_openBlock(), _createBlock(_component_message_wrapper, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["align-items-center message-container statistics", {
        'float-end': _ctx.message.isUserMessage(),
        'user-message': _ctx.message.isUserMessage()
      }])
      }, [
        _createElementVNode("button", {
          class: "btn btn-outline-primary stats",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal()))
        }, " Show statistics "),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (line.type === 'bubble')
                      ? (_openBlock(), _createBlock(_component_bubble_graph, {
                          key: 0,
                          class: "graph",
                          title: line.graph.title,
                          "x-average": line.graph.axis.x.average,
                          "y-average": line.graph.axis.y.average,
                          "x-title": line.graph.axis.x.title,
                          "y-title": line.graph.axis.y.title,
                          "x-prefix": line.graph.axis.x.prefix,
                          "y-prefix": line.graph.axis.y.prefix,
                          "x-suffix": line.graph.axis.x.suffix,
                          "y-suffix": line.graph.axis.y.suffix,
                          data: line.graph.values
                        }, null, 8, ["title", "x-average", "y-average", "x-title", "y-title", "x-prefix", "y-prefix", "x-suffix", "y-suffix", "data"]))
                      : _createCommentVNode("", true),
                    (line.type === 'bar')
                      ? (_openBlock(), _createBlock(_component_bar_graph, {
                          key: 1,
                          class: "graph",
                          title: line.graph.title,
                          "bar-label": line.graph.bar.label,
                          "x-title": line.graph.axis.x.title,
                          "y-title": line.graph.axis.y.title,
                          "x-prefix": line.graph.axis.x.prefix,
                          "y-prefix": line.graph.axis.y.prefix,
                          "x-suffix": line.graph.axis.x.suffix,
                          "y-suffix": line.graph.axis.y.suffix,
                          data: line.graph.values
                        }, null, 8, ["title", "bar-label", "x-title", "y-title", "x-prefix", "y-prefix", "x-suffix", "y-suffix", "data"]))
                      : _createCommentVNode("", true),
                    (line.type === 'message')
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 2,
                          class: "text",
                          innerHTML: _ctx.getSafeHtml(line.text)
                        }, null, 8, _hoisted_6))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ])
            ])
          ])
        ], 512)
      ], 2)
    ]),
    _: 1
  }))
}